{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "System",
    "AVATAR": {
      "SUCCESS_DELETE": "Bottens avatar har tagits bort",
      "ERROR_DELETE": "Det gick inte att ta bort bottens avatar, försök igen"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Bot name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "What does this bot do?"
      },
      "BOT_CONFIG": {
        "ERROR": "Please enter your CSML bot configuration above.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Validate and save"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Uppdatera",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Botar per land",
        "DESC": "Den här inkorgen betjänar flera länder. En konversation går till botten för sitt land: efter Kauflands butik, efter marknadsplatsen för Allegro-ordern, annars efter det språk köparen skriver på. Alla andra konversationer går till standardbotten ovan.",
        "COUNTRY": "Välj ett land",
        "BOT": "Välj en bot",
        "ADD": "Lägg till bot för land",
        "REMOVE": "Ta bort",
        "DEFAULT_REQUIRED": "Välj först en standardbot. Ett lands bot ersätter den bara för det landet.",
        "DISCONNECT_ALL": "Koppla bort alla botar"
      }
    },
    "ADD": {
      "TITLE": "Configure new bot",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Bot-detaljer",
        "URL": "Webhook-URL"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Radera",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Bekräfta borttagning",
        "MESSAGE": "Är du säker på att du vill ta bort {name}?",
        "YES": "Ja, ta bort",
        "NO": "Nej, behåll"
      },
      "SUBMIT": "Radera",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "DESCRIPTION": "Are you sure you want to delete this bot? This action is irreversible.",
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Redigera",
      "LOADING": "Fetching bots...",
      "TITLE": "Edit bot",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Botens avatar"
      },
      "NAME": {
        "LABEL": "Botens namn",
        "PLACEHOLDER": "Ange botens namn"
      },
      "DESCRIPTION": {
        "LABEL": "Beskrivning",
        "PLACEHOLDER": "Vad gör den här boten?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook-URL",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Botens namn krävs",
        "URL": "Webhook-URL krävs",
        "VALID_URL": "Ange en giltig URL som börjar med http:// eller https://"
      },
      "CANCEL": "Avbryt",
      "CREATE": "Skapa bot",
      "UPDATE": "Uppdatera bot"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
